<nwm-menu />

<div class="content">
  <div class="main">
    <div class="row no-gutters mb-5 mt-4">
      <div class="col-xxl-10 offset-xxl-1">
        <pgf-pie />

        <h1 class="mt-5 mb-4">Nicola Wealth Private Giving Foundation</h1>
        <p>Nicola Wealth Private Giving Foundation manages Donor Advised Funds (DAF), aligning financial planning and philanthropic goals with strategic charitable impact. Established in 1996, the Nicola Wealth Private Giving Foundation is currently ranked #1 for Investment Counsellors in Canada and in the top 5 for Financial Institutions.*</p>
        <p>A Donor Advised Fund is a simple, flexible, and tax-advantageous way to give, while maximizing your charitable impact.</p>
        <p>With a Donor Advised Fund, you can easily donate right away, while taking the time to thoughtfully explore and choose the causes and organizations you want to support. This approach lets you define the impact you want to have, ensuring your giving aligns with your values and goals. The Nicola Wealth Private Giving Foundation manages 450+ Donor Advised Funds (as at July 2024) to support thousands of registered charities and qualified donees in Canada.</p>

        <p class="mb-5"><small><i>* Influence, Affluence and Opportunity: Donor-advised Funds in Canada, produced in 2023 in partnership with CAGP Foundation and KCI</i></small></p>

        <pgf-how-it-works type="nopgf" />
      </div>
    </div>
    <div class="row mb-5 mt-4 join-section">
      <div class="col-xxl-10 offset-xxl-1">
        <p class="pt-4"><b>Thinking of joining our community of donors? Let's start the conversation.</b></p>
        <button class="btn btn-NWM btn-light" (click)="modalService.open(pgfModal, { size: 'lg' })">Contact Advisory Team</button>
      </div>
    </div>
    <div class="row mt-4" style="background:#F1F0E3">
      <div class="col-xxl-10 offset-xxl-1 py-5">
        <div class="row">
          <div class="col-md-4">
            <h1>Benefits to you, your family, & your community</h1>
            <p class="pt-4">Help your philanthropic dollars reach charities thoughtfully, generously, and strategically.</p>
          </div>
          <div class="col-md-8 pl-md-5">
            <div class="row no-gutters">
              <div class="col-3"><b>Time flexibility</b></div>
              <div class="col-9">Give a large sum now, receive a tax receipt, and disburse to your favourite charities over time.</div>
            </div><hr>
            <div class="row no-gutters">
              <div class="col-3"><b>Tax savings</b></div>
              <div class="col-9">Contributions provide immediate tax savings.</div>
            </div><hr>
            <div class="row no-gutters">
              <div class="col-3"><b>Professionally managed</b></div>
              <div class="col-9">Professional investment management of all Donor Advised Funds that utilizes our focus on cash flow and asset protection.</div>
            </div><hr>
            <div class="row no-gutters">
              <div class="col-3"><b>Professionally managed</b></div>
              <div class="col-9">Professional investment management of all Donor Advised Funds that utilizes our focus on cash flow and asset protection.</div>
            </div><hr>
            <div class="row no-gutters">
              <div class="col-3"><b>Sustained giving</b></div>
              <div class="col-9">Make substantial donations in profitable years and sustain a similar level of disbursements in lean times.</div>
            </div><hr>
            <div class="row no-gutters">
              <div class="col-3"><b>Give in-kind</b></div>
              <div class="col-9">Have the ability to give gifts in-kind instead of being limited to cash donations.</div>
            </div><hr>
            <div class="row no-gutters">
              <div class="col-3"><b>Make it a family affair</b></div>
              <div class="col-9">Involve children to help them understand the importance of giving and charitable impact.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row no-gutters mb-5 mt-4 pb-5">
      <div class="col-xxl-10 offset-xxl-1 pb-5">

        <button routerLink="/pgf-intro/news" class="btn btn-outline-primary d-print-none pull-right mt-5">Explore All News</button>
        <h1 class="mt-5 mb-3" id="pgf_news" data-offset="-80">Recent News in the Community</h1>
        <news topic="PGF" [limit]="4" />

        <h1 class="mt-5 mb-4">Nicola Wealth in the Community</h1>
        <p>Nicola Wealth is an active member of our communities, giving back and getting involved to help build a vibrant future. <a href="https://nicolawealth.com/insights/category/community" target="_blank">Learn about how our initiatives are making an impact and redefining success.</a></p>
      </div>
    </div>
  </div>

</div>

<ng-template #pgfModal let-modal>
  <nwm-advisor-contact formAction="MessageAdvisor" (formCancelled)="modal.close()" />
</ng-template>